/* eslint no-prototype-builtins: "off" */

'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

const zone = require('./../../../../services/structure/zone');
const Container = require('./../../../../core/container');
const Mediator = require('./../../../../core/mediator');
const Translator = require('./../../../../core/translator');
const Resizer = require('./../../service/resizer');
const Uploader = require('./../../service/uploader');
const Loader = require('./../../../../services/loader');
const Help = require('./../../../../services/help');
const UserPrefRepository = require('./../../repository/UserPreferenceRepository');
const Dropzone = require('./../../service/dropzone');

const tpl = require('./template/index.hbs');

const sizes = [
    {'width': 16, 'height': 16},
    {'width': 32, 'height': 32},
    {'width': 144, 'height': 144},
    {'width': 152, 'height': 152},
];

let faviconData = {};

const processUpload = (file, size) => {
    let dfd = jQuery.Deferred();
    let name = `favicon_${size.width}x${size.height}.png`;

    Resizer.resize(file, size.width, size.height, 100).done((src) => {
        Uploader.upload(file, {name, src}).done((response) => {
            faviconData[name.replace('favicon', 'url').replace('.png', '')] = Container.get('getResourceUrl')(response.path);

            dfd.resolve(file, src, name);
        });
    });

    return dfd.promise();
};

const processMultipleUpload = function(file) {
    let promises = [];

    _.forEach(sizes, (size) => {
        promises.push(processUpload(file, size));
    });

    return jQuery.when.apply(undefined, promises).promise();
};

const updateImage = function($tpl, url, name) {
    let $container = $tpl.find('.img-container');

    $container.removeClass('d-none');
    $container.html('');
    $container.append(jQuery(`<img src="${url}" />`));
    $tpl.find('.cloud-label').html(name);
};

module.exports.onMenuClick = function() {
    let $tpl = jQuery(tpl());
    let $imgContainer = $tpl.find('.img-container');
    let $btnRemove = $tpl.find('.btn-remove');
    let $dropzone = Dropzone.create({
        'accepted_files': 'image/png',
        'label': 'drop_favicon_label',
        'onChange': (file) => {
            Loader.start($imgContainer);

            processMultipleUpload(file).done(function() {
                $btnRemove.removeClass('d-none');
                $dropzone.addClass('d-none');

                Loader.stop($imgContainer);

                updateImage($tpl, faviconData['url_152x152'], Translator.translate('favicon_change'));
            });
        },
    });

    $tpl.find('.dropzone-wrapper').append($dropzone);

    Loader.start($imgContainer);
    UserPrefRepository.find('favicon').done(function(data) {
        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                faviconData[key] = data[key];
            }
        }

        if (data['url_152x152']) {
            updateImage($tpl, data['url_152x152'], Translator.translate('favicon_change'));
            $dropzone.addClass('d-none');
        } else {
            $imgContainer.addClass('d-none');
            $btnRemove.addClass('d-none');
        }

        Loader.stop($imgContainer);
    });

    $btnRemove.on('click', function() {
        $dropzone.removeClass('d-none');
        $imgContainer.addClass('d-none');
        $imgContainer.html('');
        faviconData = {};
        $btnRemove.addClass('d-none');
    });

    let $panel = zone.addLayer(Translator.translate('favicon'), $tpl, {
        'extraTitle': Help.createLink('favicon'),
    });

    zone.setFooter($panel, zone.createSubmitButtons({
        onCancelClick: function() {
            Mediator.publish('menu:close');
            faviconData = {};
        },
        onSubmitClick: function() {
            if ($imgContainer.children().length) {
                UserPrefRepository.save('favicon', faviconData).done(function() {
                    window.location.reload();
                });
            } else {
                UserPrefRepository.del('favicon').done(function() {
                    window.location.reload();
                });
            }
        },
    }));
};
